import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const participantTypes = [{
  title: 'Solo Founders',
  description: "You've built alone and know what's missing. Your experience helps us identify early signals in future partnerships.",
  duration: '15 min interview',
  hasForm: true,
  href: '/solo-survey',
  buttonText: 'SHARE YOUR EXPERIENCE'
}, {
  title: 'Cofounders',
  description: "You're living the partnership daily. We want to learn from your real dynamics—the wins, the friction, and everything between.",
  duration: '25 min interview',
  hasForm: true,
  href: '/cofounder-survey',
  buttonText: 'SHARE YOUR PARTNERSHIP'
}, {
  title: 'Coaches & Advisors',
  description: "You've seen inside many partnerships. Your perspective reveals patterns leaders often miss.",
  duration: '20 min interview',
  hasForm: true,
  href: '/mentor-survey',
  buttonText: 'SHARE YOUR PERSPECTIVE'
}, {
  title: 'Investors & Accelerators',
  description: 'You evaluate teams and predict outcomes. Help us understand what signals matter most.',
  duration: '20 min interview',
  hasForm: true,
  href: '/investor-survey',
  buttonText: 'SHARE YOUR INSIGHTS'
}];
const benefits = ['Early access to research findings', 'Partnership health assessment framework', 'Invitation to founder roundtables', 'Priority access to future tools'];
export function JoinResearchSection() {
  return <section id="join-research" className="px-4 sm:px-8 md:px-[60px] py-[140px] bg-gradient-to-b from-[#C5F467] to-[#B5EAD7]" data-id="element-1063">
      <div className="max-w-[1400px] mx-auto" data-id="element-1064">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-1065">
          <div className="inline-flex items-center px-4 py-2 rounded bg-[#1A3D3A] text-white mb-8" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '12px',
          fontWeight: 600,
          letterSpacing: '3px',
          lineHeight: 1.0,
          borderRadius: '4px'
        }} data-id="element-1066">
            JOIN THE RESEARCH
          </div>
          <h2 className="text-[#1A3D3A] mb-6" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 'clamp(40px, 5vw, 56px)',
          fontWeight: 500,
          lineHeight: 1.1,
          letterSpacing: '-1px'
        }} data-id="element-1067">
            Share Your Experience
          </h2>
          <p className="text-[#3D5654] max-w-2xl mx-auto" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '17px',
          fontWeight: 400,
          lineHeight: 1.8
        }} data-id="element-1068">
            Your insights contribute to a growing dataset and unlock access to
            findings that help you strengthen your own partnerships.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-[24px] mb-16" data-id="element-1069">
          {participantTypes.map((type, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-[16px] p-8 flex flex-col" style={{
          boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)'
        }} data-id="element-1070">
              <h3 className="text-[#1A3D3A] mb-4" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '26px',
            fontWeight: 500,
            lineHeight: 1.3
          }} data-id="element-1071">
                {type.title}
              </h3>
              <p className="text-[#3D5654] mb-6 flex-grow" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: 1.6
          }} data-id="element-1072">
                {type.description}
              </p>
              <p className="text-[#1A3D3A] mb-6" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 600
          }} data-id="element-1073">
                {type.duration}
              </p>

              {type.hasForm ? <a href={type.href} className="w-full px-[40px] py-[18px] bg-[#1A3D3A] text-white rounded hover:opacity-90 hover:-translate-y-0.5 transition-all focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2 mt-auto text-center block" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '1px',
            borderRadius: '4px'
          }} data-id="element-1074">
                  {type.buttonText}
                </a> : <button disabled className="w-full px-[40px] py-[18px] bg-[#3D5654] text-white/60 rounded cursor-not-allowed mt-auto" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '1px',
            borderRadius: '4px',
            opacity: 0.5
          }} data-id="element-1075">
                  COMING SOON
                </button>}
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[16px] p-12 text-center" style={{
        boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)'
      }} data-id="element-1076">
          <h3 className="text-[#1A3D3A] mb-8" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '48px',
          fontWeight: 500,
          lineHeight: 1.15
        }} data-id="element-1077">
            What You'll Receive
          </h3>
          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-1078">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3 text-left" data-id="element-1079">
                <Check className="w-5 h-5 text-[#1A3D3A] flex-shrink-0" data-id="element-1080" />
                <span className="text-[#3D5654]" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '15px',
              fontWeight: 400,
              lineHeight: 1.6
            }} data-id="element-1081">
                  {benefit}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}